import { FooterMaximized } from "components/footerfull";
import Header from "components/headerfull";
import { RoundGreyOutline, RoundGreyPlain, RoundWhitePlain } from "components/ui/Buttons/generic/GenericButton";
import { useEffect, useRef, useState } from "react";
import Location from "../location.svg";
import Mail from "../mail.svg";
import { Link } from "react-router-dom";
import { post } from "services/config";
// import Form from "components/ui/Forms";
// import Input from "components/ui/Forms/Input";
// import Select from "components/ui/Forms/Select";
import ReactCountryFlag from "react-country-flag";
import { countryCode } from "../constants";
// import Select from "react-select/dist/declarations/src/Select";
import Select, { SelectInstance } from "react-select";
// import PhoneInputWithCountrySelect, { PhoneNumber } from "react-phone-number-input";

/**
 * Makes a post request to 'url' with the parameters 'data'.
 * @param url string
 * @param data Record<string, any>
 * @returns any
 */
async function postData(url = "", data = {}) {
    try{
        const response = await fetch(url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
        });
    
        if(!response.ok){
            throw new Error('HTTP error : ');
        } else {
            return response.json();
        }
    } catch(error) {
        console.log(error);
        let erroredResponse={error: error};
        return erroredResponse;
    }
}

/**
 * Stes the description of the current page to whatever is passed through 'desc'
 * @param desc string
 */
const setDescription = (desc: any) => {
    const el = document.querySelector("meta[name='description']");
    if(el!== null){
        el.setAttribute('content',desc);
    }
}

export default function Contact(){

    useEffect(()=> {
        document.title= "Contactez Wall of Share - Support et infos";
        const desc= "Besoin d'aide ou d'informations ? Contactez Wall of Share, nous sommes là pour répondre à toutes vos questions et vous accompagner.";
        setDescription(desc);
    },[]);
    
    return (
        <>
        <Header type="default" />
            <MainContactBanner />
            <MiniCallToAction />
        <FooterMaximized />
        </>
    );
};

const MiniCallToAction= () => {
    return (
        <>
            <div className="w-full md:px-[108px] md:py-[114.5px] px-[35px] pt-[80px] pb-[142px] ">
                <div className="max-w-[1225px] flex md:flex-row md:gap-0 flex-col gap-[82px] md:justify-between relative md:items-center items-start mx-auto with-separator">
                    <div className="flex flex-col gap-[10px] md:max-w-[550px] md:w-[45%] max-w-[400px] w-[90%]">
                        <div className="bg-gradient-to-r text-[18px] leading-[21.6px] from-purple-500 via-red-500 to-orange-500 bg-clip-text text-transparent font-semibold w-max">Vous êtes une entreprise ?</div>
                        <h2 className="text-[25px] leading-[30px] font-semibold text-[#1d1d39]">Confiez votre projet à Wall of Share !</h2>
                        <p className="text-[16px] leading-[20.83px] font-normal text-[#6f6f6f] font-dm-sans">Trouvez rapidement le talent qui correspond à vos besoins et simplifiez votre recrutement.</p>
                        <RoundWhitePlain text="Trouver un talent" isButton={false} className="px-[20px] py-[10px] text-[14px] leading-[18.23px] font-semibold" to="/inscription-entreprises" />
                    </div>
                    <div className="flex flex-col gap-[10px] md:max-w-[550px] md:w-[45%] max-w-[400px] w-[90%]">
                        <div className="bg-gradient-to-r text-[18px] leading-[21.6px] from-purple-500 via-red-500 to-orange-500 bg-clip-text text-transparent font-semibold w-max">Vous êtes un talent ?</div>
                        <h2 className="text-[25px] leading-[30px] font-semibold text-[#1d1d39]">Mettez en valeur vos compétences !</h2>
                        <p className="text-[16px] leading-[20.83px] font-normal text-[#6f6f6f] font-dm-sans">Accédez à des projets qui valorisent votre expertise et trouvez des missions stimulantes.</p>
                        <RoundWhitePlain text="Trouver un projet" isButton={false} className="px-[20px] py-[10px] text-[14px] leading-[18.23px] font-semibold" to="/inscription-freelances" />
                    </div>
                </div>
            </div>
        </>
    );
};

const MainContactBanner= () => {

    const ThanksLink= useRef<HTMLAnchorElement>(null);
    const ErrorLink= useRef<HTMLAnchorElement>(null);
    const [isSending, setIsSending]= useState(false);
    const [values, setValues]= useState({
        type: "",
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: ""
    });
	
	const [formErrors, setFormErrors]= useState<any>({});

    const handleInputs=(e: any)=> {
        if (e.target.name=== "type"){
			delete formErrors.type;
            setValues({...values, ["type"]: e.target.value});
            return;
        }
        setValues({...values, [e.target.name]: e.target.value});
		delete formErrors[e.target.name];
    };

    const submitForm= async (e: any) => {
        e.preventDefault();
        setIsSending(true);
        // alert("Form is submited");
		const newErrors= validate(values);
		setFormErrors(newErrors);
        // console.log(newErrors);
		
		if (Object.keys(newErrors).length=== 0){
			// const response= await postData("https://portal.wall-of-share.com/api/contact-form", values);//<-Might need to refactor later. <-for prod
			const response= await post("/api/contact-form", values);

            // console.log(response);
            
			// const response= await postData("http://18.214.15.206/api/contact-form", values);//<-Might need to refactor later.<-for dev
			// console.log(values);
			// console.log(response.result.status);

            if ((response.status=== 200) && (response.data)) {
                const data: any= response.data;
                if (data.result && data.result.status=== "success") {
                    if(ThanksLink.current){
                        ThanksLink.current.click();
                    }
                } else {
                    if (ErrorLink.current) {
                        ErrorLink.current.click();
                    }
                }
            } else {
                if (ErrorLink.current) {
                    ErrorLink.current.click();
                }
            }
		} else {
			setIsSending(false);
		}
        return 0;
    };
	
	const validate= (data: any) => {
		const newErrors: any= {};
		
		if (!data.type.trim()){
			newErrors.type= "Vous devez séléctionner une option";
		}
		
		if(!data.name.trim()){
			newErrors.name= "Vous devez entrer votre nom";
		} else if (data.name.trim().length < 4){
			newErrors.name= "Le nom entré est trop court";
		}
		
		if(!data.email.trim()){
			newErrors.email= "Vous devez entrer votre email";
		} else if (!/\S+@\S+\.\S+/.test(data.email)){
			newErrors.email= "Le format de l'email n'est pas valide";
		}
		
		if(!data.message.trim()){
			newErrors.message= "Votre message ne doit pas être vide";
		} else if (data.message.trim().length <= 10){
			newErrors.message= "Le message entré est trop court";
		}

        if(!data.phone.trim()){
            newErrors.phone= "Vous devez entrer un numéro de téléphone";
        } else if (data.phone.trim().length <= 7) {
            newErrors.phone= "Le numéro entré est trop court.";
        }
		
		return newErrors;
	};

    const phoneRef= useRef<HTMLInputElement>(null);

    const countries = countryCode.map((el)=> ({ value: el.value, label: el.label, code: el.label, shortCode: el.value.split(' ')[0]}));

    // const countries = [
    //     { value: "FR", label: <><ReactCountryFlag countryCode="FR" svg /> France</> },
    //     { value: "CN", label: <><ReactCountryFlag countryCode="CN" svg /> China</> },
    //     { value: "CY", label: <><ReactCountryFlag countryCode="CY" svg /> Cyprus</> }
    // ];

    const findCountryByNumber= (thePhoneNumber: string) => {
        for (let codeLength= 6; codeLength >= 1; codeLength--) {
            const potentialCode= thePhoneNumber.substring(0, codeLength);
            const foundCountry= countries.find(element=> element.shortCode=== `${potentialCode}`);

            if(foundCountry) {
                return (foundCountry);
            }
        }
        return undefined;
    }

    const [opts, setOpts]= useState(countries[59]);// default it to 'FR'
    const handleOptChanges= (state: any) => {
        // console.log(state);
        if (phoneRef.current) {
            const thePhoneNumber= phoneRef.current.value;
            const oldCountryCode= opts.shortCode;
            const newPhoneNumber= thePhoneNumber.replace(oldCountryCode, state.shortCode);
            setValues({...values, [phoneRef.current.name]: newPhoneNumber});
        }
        setOpts(state);
    };
    
    const selectRef= useRef<any>(null);

    const handlePhoneChange= (event: any) => {
        if (findCountryByNumber(event.currentTarget.value)) {
            // console.log(findCountryByNumber(event.currentTarget.value));
            selectRef.current.setValue(findCountryByNumber(event.currentTarget.value));
        }
        setValues({...values, [event.currentTarget.name]: event.currentTarget.value});
    };

    return (
        <div className="w-full bg-[#f4f4f5] md:pt-[120px] lg:pb-[120px] pt-[62px] px-[35px]">
            <div className="flex lg:flex-row flex-col lg:gap-[auto] gap-[20px] lg:justify-between lg:items-stretch lg:max-w-[1069px] max-w-[503px] lg:w-full mx-auto">
                <div className="flex flex-col gap-[40px] lg:w-[503px]">
                    <div className="lg:h-[618px] md:h-[250px] h-[150px] w-full rounded-[1.8rem] overflow-hidden">
                        <img src="/contact-images/contact.webp" alt="Agent de support client" className="lg:h-full lg:w-auto w-full max-w-[unset] relative lg:left-[-70px] lg:top-0 md:top-[-50%] min-[400px]:top-[-25vw] top-[-15vw]"/>
                    </div>
                    <div className="w-full lg:flex flex-col gap-3 hidden">
                        <div className="w-full flex flex-row gap-2">
                            <img src={Location} alt="Location" />
                            <p className="text-[20px] leading-[26.04px] font-normal text-[#6f6f6f]">198 avenue de Verdun 92130, Issy les Moulineaux</p>
                        </div>
                        <div className="w-full flex flex-row gap-2">
                            <img src={Mail} alt="Mail" />
                            <p className="text-[20px] leading-[26.04px] font-normal text-[#6f6f6f]">contact@wall-of-share.com</p>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col gap-[20px] lg:w-[503px] h-auto lg:pb-[102px]">
                    <h2 className="text-[30px] leading-[36px] md:text-[40px] md:leading-[48px] text-[#1d1d39] font-semibold">Contactez-nous</h2>
                    <p className="md:text-[18px] md:leading-[23.64px] text-[16px] leading-[20.83px] font-normal font-dm-sans text-[#6f6f6f]">Contactez-nous pour tout ce qui concerne notre entreprise ou nos services. Nous ferons de notre mieux pour vous répondre dans les plus brefs délais.</p>
                    <form onSubmit={submitForm} className="wos-contact-form w-full">
                        <div className="wos-form-group">
							{ formErrors.type && <div className="wos-form-error" >{formErrors.type}</div> }
                            <span className="text-[18px] leading-[23.44px] text-[#6f6f6f] font-normal mr-[2rem] w-max font-semibold">Vous êtes ?</span>
                            <div className="flex flex-row items-center gap-[1em] flex-wrap">
                                <div className="wos-input-group w-max">
                                    <input type="radio" id="freel" name="type" value="freelance" onChange={handleInputs} checked={values.type=== "freelance"? true : false}/>
                                    <label htmlFor="freel" className="text-[18px] leading-[23.44px] font-semibold">Un freelance</label>
                                </div>
                                <div className="wos-input-group w-max">
                                    <input type="radio" id="enterp" name="type" value="entreprise" onChange={handleInputs} checked={values.type=== "entreprise"? true : false}/>
                                    <label htmlFor="enterp" className="text-[18px] leading-[23.44px] font-semibold">Une entreprise</label>
                                </div>
                            </div>
                        </div>
                        <div className="wos-form-group">
							{ formErrors.name && <div className="wos-form-error" >{formErrors.name}</div> }
                            <div className="wos-input-group">
                                <label htmlFor="nom" className="text-[18px] leading-[23.44px] font-semibold">Votre nom</label>
                                <input type="text" id="nom" name="name" onChange={handleInputs} value={values.name} placeholder=" "/>
                            </div>
                        </div>
                        <div className="wos-form-group">
							{ formErrors.email && <div className="wos-form-error" >{formErrors.email}</div> }
                            <div className="wos-input-group">
                                <label htmlFor="email" className="text-[18px] leading-[23.44px] font-semibold">Votre adresse mail</label>
                                <input type="email" id="email" name="email" onChange={handleInputs} value={values.email} placeholder=" "/>
                            </div>
                        </div>
                        <div className="wos-form-group">
							{ formErrors.phone && <div className="wos-form-error" >{formErrors.phone}</div> }
                            <div className="wos-input-group">
                                <Select
                                    ref={selectRef}
                                    // unstyled
                                    styles={{
                                        control: (baseStyles, states) => ({
                                            ...baseStyles,
                                            border: 'none',
                                            outine: 'none',
                                            borderColor: 'transparent',
                                            boxShadow: 'none',
                                            backgroundColor: '#f4f4f5',
                                            minHeight: 'unset',
                                            flexGrow: '0',
                                            width: 'max-content'
                                        }),
                                        dropdownIndicator: (baseStyles, states)=> ({
                                            ...baseStyles,
                                            height: 'max-content'
                                        }),
                                        indicatorSeparator: (baseStyles, states)=> ({
                                            border: 'none',
                                            width: '0'
                                        }),
                                        indicatorsContainer: (baseStyles, states)=> ({
                                            padding: '0px!important'
                                        }),
                                        valueContainer: (baseStyles, states)=> ({
                                        }),
                                        clearIndicator: (baseStyles, states) => ({
                                            padding: '0'
                                        }),
                                        menu: (baseStyles, states)=> ({
                                            width: '200px',
                                            position: 'absolute',
                                            zIndex: '80',
                                            background: 'white'
                                        }),
                                        container: (baseStyles, states) => ({
                                            position: 'relative'
                                        })
                                        
                                    }}
                                    isSearchable={true}
                                    options={countries}
                                    value={opts}
                                    onChange={handleOptChanges}
                                    getOptionLabel={(e) => e?.label || ''}
                                    components={{
                                        Option: ({ data, innerRef, innerProps }) => (
                                            <div style={{ display: "flex", alignItems: "center", padding: "5px", cursor: "pointer", width: "100%" }} ref={innerRef} {...innerProps}>
                                                <ReactCountryFlag countryCode={data?.code || 'FR'} svg />
                                                <span style={{ marginLeft: "5px" }}>{data?.value}</span>
                                            </div>
                                        ),
                                        SingleValue: ({ data }) => (
                                            <ReactCountryFlag countryCode={data?.code || 'FR'} svg />   
                                        )
                                    }}
                                />
                                <input type="text" id="phone" name="phone" onChange={handlePhoneChange} value={values.phone} placeholder=" " ref={phoneRef}/>
                            </div>
                        </div>
                        <div className="wos-form-group">
                            <div className="wos-input-group">
                                <label htmlFor="sujet" className="text-[18px] leading-[23.44px] font-semibold">Votre sujet</label>
                                <input type="text" id="sujet" name="subject" onChange={handleInputs} value={values.subject} placeholder=" "/>
                            </div>
                        </div>
                        <div className="wos-form-group flex1">
							{ formErrors.message && <div className="wos-form-error" >{formErrors.message}</div> }
                            <div className="wos-input-group message">
                                <label htmlFor="message" className="text-[18px] leading-[23.44px] font-semibold">Votre message</label>
                                <textarea name="message" id="message" className="w-full" onChange={handleInputs} value={values.message}></textarea>
                            </div>
                        </div>
                        {isSending ? 
                        <RoundGreyOutline text={"Envoi..."} isButton={true} className="px-[27px] py-[13.5px] text-[18px] leading-[23.44px]" type="submit" noCursor={true}/>
                        :
                        <RoundGreyPlain text={"Envoyer"} isButton={true} className="px-[27px] py-[13.5px] text-[18px] leading-[23.44px]" type="submit"/>
                        }

                    </form>
                </div>
                <div className="w-full lg:hidden flex flex-col gap-3 my-[4rem] mb-[5rem]">
                    <div className="w-full flex flex-row gap-2">
                        <img src={Location} alt="Location" />
                        <p className="text-[20px] leading-[26.04px] font-normal text-[#6f6f6f]">198 avenue de Verdun 92130, Issy les Moulineaux</p>
                    </div>
                    <div className="w-full flex flex-row gap-2">
                        <img src={Mail} alt="Mail" />
                        <p className="text-[20px] leading-[26.04px] font-normal text-[#6f6f6f]">contact@wall-of-share.com</p>
                    </div>
                </div>
            </div>
            <Link to={"/merci"} className="hidden" aria-hidden="true" ref={ThanksLink}/>
            <Link to={"/erreur"} className="hidden" aria-hidden="true" ref={ErrorLink}/>
        </div>
    );
};
